import React from 'react';
import BrianAnimated from './BrainAnimated';

const MathLoading = () => {
  return <BrianAnimated />;
};

export default MathLoading;
